import moment from "moment";

export const newCoupon = () => {
  const coupon = new Coupon();
  coupon.expireAt = moment().format("YYYY-MM-DD HH:mm");
  return coupon;
}

export const COUPON_LOCAL_STORAGE_PREFIX = "coupon_txid_";

export const couponLocalStoragePrefix = (couponId) => {
  return COUPON_LOCAL_STORAGE_PREFIX + `${couponId}_`;
}

//provide Type
export const COUPON_LIMITED = "LIMITED";
export const COUPON_UNLIMITED = "UNLIMITED";

//confirm Type
export const COUPON_LOCK = "LOCK";
export const COUPON_UNLOCK = "UNLOCK";

//usage Type
export const COUPON_APP = "APP";
export const COUPON_WEB = "WEB";

export default class Coupon {
  adAccountId = 0;
  appId = 0;
  appName = "";
  description = "";
  expireAt = "";
  image = "";
  name = "";
  provideType = COUPON_UNLIMITED;
  usageUrl = {
    AOS:"",
    IOS:"",
    PC:""
  }
}
